var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxlLightPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07119 8.73485L12.0282 5.77785L2.47719 0.409847C1.84419 0.0678473 1.25119 0.0198475 0.731187 0.393847L9.07119 8.73485ZM12.5322 12.1968L15.6062 10.4678C16.2062 10.1318 16.5352 9.65585 16.5352 9.12785C16.5352 8.60085 16.2062 8.12385 15.6072 7.78785L12.8242 6.22485L9.69119 9.35685L12.5322 12.1968ZM0.217187 1.12085C0.153187 1.31785 0.117188 1.53785 0.117188 1.77885V16.4838C0.117188 16.8648 0.201188 17.1928 0.353188 17.4538L8.45019 9.35585L0.217187 1.12085ZM9.07119 9.97585L1.01919 18.0288C1.17319 18.0878 1.33919 18.1188 1.51419 18.1188C1.82619 18.1188 2.15119 18.0268 2.48219 17.8428L11.7372 12.6458L9.07119 9.97585Z",
    fill: "#191916"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxlLightPlay);
export default __webpack_public_path__ + "static/media/bxl_light_play.2c1d7616bf6bfde6d40b847282c49ca0.svg";
export { ForwardRef as ReactComponent };